module.exports = __webpack_public_path__ + "static/media/br-sc.2d99f8d0.svg";